import { config } from "./config";

const chain = config.token.chain;

export const hasProvider = () => typeof window !== "undefined" && !!window.ethereum;

export async function connectWallet() {
  if (!hasProvider()) return { status: "no_provider" };
  try {
    const accounts = await window.ethereum.request({ method: "eth_requestAccounts" });
    const chainId = await window.ethereum.request({ method: "eth_chainId" });
    if (!accounts?.length) return { status: "disconnected" };
    return { status: chainId === chain.chainIdHex ? "connected" : "wrong_network", account: accounts[0], chainId };
  } catch (e) {
    if (e?.code === 4001) return { status: "rejected" };
    return { status: "error", message: e?.message };
  }
}

export async function switchToChain() {
  try {
    await window.ethereum.request({ method: "wallet_switchEthereumChain", params: [{ chainId: chain.chainIdHex }] });
    return true;
  } catch {
    return false;
  }
}

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");
